<template>
  <div style="min-height: 100vh; background-color: #fafafa" class="px-5 py-5">
    <!-- security and graph section -->
    <div>
      <v-card class="py-5">
        <v-card-title v-if="infoLoader">
          <v-skeleton-loader
            width="100%"
            type="list-item-avatar,article"
          ></v-skeleton-loader>
        </v-card-title>
        <v-card-title
          class="d-flex px-4 py-0"
          style="word-break: keep-all"
          v-else
        >
          <v-row no-gutters>
            <v-col cols="12" sm="7">
              <div>
                <div class="d-flex">
                  <div class="mr-3">
                    <v-avatar
                      size="50"
                      style="object-fit: contain; cursor: pointer"
                      color="rgba(0, 0, 0, 0.06)"
                    >
                      <img
                        :src="security.logo"
                        alt=""
                        style="aspect-ratio: 16 / 16; object-fit: contain"
                      />
                    </v-avatar>
                  </div>
                  <div>
                    <div class="security_name__class" v-if="security.symbol">
                      {{ security.symbol }}
                    </div>
                    <div
                      class="symbol_exchange__class"
                      v-if="security.exchange"
                    >
                      {{ security.exchange }} :
                      <span style="color: #333333" v-if="security.name">{{
                        security.name
                      }}</span>
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ml-1 d-flex" v-if="$vuetify.breakpoint.xsOnly">
                    <v-menu rounded="lg" offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          large
                          color="black"
                          @click="getWatchlistTabs('stock')"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-playlist-plus</v-icon
                        >
                      </template>
                      <v-list>
                        <!-- {{ security_bookmark_loading }} -->

                        <v-list-item
                          @click="addOrRemoveWatchlist(item, security)"
                          v-for="item in watchlistTabs"
                          :key="item"
                          link
                        >
                          <v-list-item-title>
                            <!-- v-if="security_bookmark_loading" -->

                            <div>
                              {{ item.name }}
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-icon
                      color="black"
                      class="ml-1"
                      @click="takeSs('ssGraphCreatorDiv')"
                      >mdi-share-variant-outline</v-icon
                    >
                  </div>
                </div>
                <div class="py-1 px-1 d-flex">
                  <div class="figures d-flex align-center">
                    <span
                      class="live-price"
                      v-if="security.live_price"
                      :class="{ change_effect: changed }"
                      >₹{{ security.live_price.toFixed(2) }}</span
                    >
                    <span
                      :class="
                        incrementDecrementData > 0 ? 'increment' : 'decrement'
                      "
                      ><v-icon
                        small
                        :color="
                          incrementDecrementData > 0 ? '#27AE60' : '#EB5757'
                        "
                        >{{ incrementDecrementIcon }}</v-icon
                      >₹{{ Math.abs(incrementDecrementData) }}</span
                    ><span
                      :class="
                        profitLossPercent > 0
                          ? 'profit-percent'
                          : 'loss-percent'
                      "
                    >
                      ({{ Math.abs(profitLossPercent) }}%)</span
                    >
                    <!-- <span class="loss-percent" v-if="1 == 4"
                        ><v-icon small color="#EB5757">arrow-down</v-icon> 10.2 %</span
                      > -->
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-none"
                    color="primary"
                    @click="addTrade()"
                  >
                    <span>Trade</span>
                  </v-btn>
                  <!-- <v-spacer v-if="$vuetify.breakpoint.xsOnly"></v-spacer>
                  <div class="graph_tab_div" v-if="$vuetify.breakpoint.xsOnly">
                    <graph-tab
                      v-model="graphType"
                      :items="graphTypeItems"
                      :disabled="infoLoader"
                    ></graph-tab>
                  </div> -->
                </div>
                <div v-if="security.is_report_available">
                  <div
                    class="d-flex justify-end my-2"
                    v-if="$vuetify.breakpoint.xsOnly"
                  >
                    <div>
                      <div class="download-text">
                        Download Stock Research Report starting from
                        <span class="rupee-text"
                          >₹{{ security.minimum_stock_price }} only</span
                        >
                      </div>
                    </div>
                    <div>
                      <v-btn
                        class="text-none ml-5"
                        color="primary"
                        outlined
                        @click="openReportList"
                        >Explore</v-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="5"
              class="pb-2 d-flex"
              :class="$vuetify.breakpoint.smAndUp ? 'justify-end' : ''"
              v-if="!$vuetify.breakpoint.xsOnly"
            >
              <v-menu rounded="lg" offset-y>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    text
                    v-bind="attrs"
                    v-on="on"
                    class="text-none text_btn"
                    :width="$vuetify.breakpoint.smAndUp ? '' : '20%'"
                    :style="
                      security.is_added_to_watchlist
                        ? 'border: 1px solid #2d8cff'
                        : ''
                    "
                    @click="getWatchlistTabs('stock')"
                  >
                    <v-icon
                      :left="$vuetify.breakpoint.smAndUp"
                      :size="$vuetify.breakpoint.smAndUp ? '25' : '20'"
                      :color="security.is_added_to_watchlist ? '#2d8cff' : ''"
                      >mdi-playlist-plus</v-icon
                    >
                    <span
                      v-if="$vuetify.breakpoint.smAndUp"
                      :style="
                        security.is_added_to_watchlist ? 'color:#2d8cff' : ''
                      "
                      v-text="
                        security.is_added_to_watchlist
                          ? 'Added to Watchlist'
                          : 'Add to Watchlist'
                      "
                    ></span>
                  </v-btn>
                </template>
                <v-list>
                  <!-- {{ security_bookmark_loading }} -->

                  <v-list-item
                    @click="addOrRemoveWatchlist(item, security)"
                    v-for="item in watchlistTabs"
                    :key="item"
                    link
                  >
                    <v-list-item-title>
                      <!-- v-if="security_bookmark_loading" -->

                      <div>
                        {{ item.name }}
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <!-- trade and share button  -->
              <v-btn
                text
                class="text-none text_btn"
                :width="$vuetify.breakpoint.smAndUp ? '' : '20%'"
                @click="takeSs('ssGraphCreatorDiv')"
              >
                <v-icon
                  :size="$vuetify.breakpoint.smAndUp ? '20' : '15'"
                  :left="$vuetify.breakpoint.smAndUp"
                  >mdi-share-variant-outline</v-icon
                >
                <span v-if="$vuetify.breakpoint.smAndUp">Share</span>
              </v-btn>
              <v-btn
                text
                class="text-none btn_trade"
                :width="$vuetify.breakpoint.smAndUp ? '' : '55%'"
                @click="addTrade()"
              >
                <span>Trade</span>
              </v-btn>

              <!--
              <v-btn text class="text-none btn_trade" v-if="$vuetify.breakpoint.smAndUp">
                <span>Trade</span>
              </v-btn> -->
            </v-col>

            <v-col v-if="!$vuetify.breakpoint.xsOnly">
              <div class="d-flex justify-end mb-2" style="margin-top: -50px">
                <div v-if="security.is_report_available">
                  <div class="download-text">
                    Download Stock Research Report starting from
                  </div>
                  <div class="rupee-text">
                    ₹{{ security.minimum_stock_price }} only
                  </div>
                </div>
                <div>
                  <v-btn
                    v-if="security.is_report_available"
                    class="text-none ml-5"
                    color="primary"
                    outlined
                    @click="openReportList"
                    >Explore</v-btn
                  >
                  <v-btn
                    v-else-if="user_detail.profile.is_sebi_registered"
                    class="text-none ml-5"
                    color="primary"
                    outlined
                    @click="uploadReportDialog"
                    >Upload</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- <v-divider> </v-divider> -->
          <v-row v-if="$vuetify.breakpoint.smAndDown" class="my-3 px-3">
            <v-expansion-panels flat style="border-top: 1.8px solid #f1f1f1">
              <v-expansion-panel class="elevation-0">
                <v-expansion-panel-header class="px-0 pl-2">
                  <div class="about_header d-xs-none">
                    About {{ security.symbol }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-sm-flex pt-2">
                    <div class="overview_text__class d-flex">
                      Industry:
                      <span
                        v-if="security.industry"
                        class="overview_text_value__class pl-1"
                        >{{ security.industry }}</span
                      >
                    </div>
                    <div class="overview_text__class ml-sm-4 d-flex">
                      Sector:
                      <span
                        v-if="security.sector"
                        class="overview_text_value__class pl-1"
                        >{{ security.sector }}</span
                      >
                    </div>
                  </div>
                  <div
                    v-if="security.description"
                    class="overview_des__class pt-3"
                  >
                    <div v-if="!desMore">
                      {{ security.description.substring(0, 330) }}...
                      <span class="show_more" @click="desMore = !desMore"
                        >Read more</span
                      >
                    </div>
                    <div v-else>
                      {{ security.description }}.
                      <span class="show_more" @click="desMore = !desMore"
                        >Read less</span
                      >
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-title>
        <v-card-text id="fullScreen" class="pb-0">
          <v-row no-gutters v-if="!resizeLoader" id="ssGraphCreatorDiv">
            <v-col
              :cols="fullSreenwidth"
              class="pa-sm-3"
              :class="
                fullSreenwidth == 8 ? 'notfullwidth__class' : 'fullwidth__class'
              "
            >
              <div
                class="d-flex align-center"
                :class="$vuetify.breakpoint.xsOnly ? 'pt-4' : 'pt-1'"
              >
                <div class="price-movement pl-2">Price Movement</div>
                <v-spacer v-if="$vuetify.breakpoint.xsOnly"></v-spacer>
                <div class="graph_tab_div" v-if="$vuetify.breakpoint.xsOnly">
                  <graph-tab
                    v-model="graphType"
                    :items="graphTypeItems"
                    :disabled="infoLoader"
                  ></graph-tab>
                </div>
              </div>

              <div v-if="graphLoader">
                <v-skeleton-loader
                  width="100%"
                  :height="$vuetify.breakpoint.smAndUp ? '500' : '300'"
                  type="card,graph"
                ></v-skeleton-loader>
              </div>
              <div class="light-graph" v-else>
                <light-weight-graph
                  :security="security"
                  v-model="timeSeries"
                  :graph="graphType"
                  v-if="timeSeries.length"
                ></light-weight-graph>
              </div>

              <!-- graph actions -->
              <div
                class="d-sm-flex"
                :class="fullSreenwidth == 8 ? 'tab_container__class' : ''"
                v-if="timeSeries.length"
              >
                <div class="graph_tab_div" v-if="$vuetify.breakpoint.smAndUp">
                  <graph-tab
                    v-model="graphType"
                    :items="graphTypeItems"
                    :disabled="infoLoader"
                  ></graph-tab>
                </div>
                <div
                  :class="$vuetify.breakpoint.smAndUp ? 'ml-3' : 'mt-2 pb-2'"
                >
                  <date-filter-tab
                    v-model="filterValue"
                    :disabled="graphLoader || infoLoader"
                    :items="filterItems"
                  ></date-filter-tab>
                </div>
                <div v-if="!graphLoader && !infoLoader" class="pl-3">
                  <div v-if="$vuetify.breakpoint.smAndUp">
                    <img
                      src="@/assets/securitypage/fullwidth.svg"
                      alt=""
                      v-if="fullSreenwidth !== 12"
                      @click="fullWidth(fullSreenwidth)"
                    />
                    <img
                      src="@/assets/securitypage/fullwidthexit.svg"
                      alt=""
                      v-else
                      @click="fullWidth(fullSreenwidth)"
                    />
                  </div>
                  <!-- <img
                    src="@/assets/securitypage/fullscreen.svg"
                    alt=""
                    @click="fullScreen"
                  />
                  <img
                    src="@/assets/securitypage/fullscreenexit.svg"
                    alt=""
                    @click="fullScreen"
                  /> -->
                </div>
              </div>
              <!-- <div v-if="!timeSeries.length && $vuetify.breakpoint.smAndUp" class="pb-7">
                <price-summary :item="security"></price-summary>
                <TechnicalAnalysisWidget
                  :exchange="security.exchange"
                  :symbol="security.symbol"
                />
              </div> -->
            </v-col>
            <v-col
              :cols="getCols()"
              :class="fullSreenwidth == 8 ? 'notfullwidth__class' : ''"
              class="pb-0"
              v-if="fullSreenwidth == 8 && timeSeries.length"
            >
              <v-skeleton-loader
                width="100%"
                type="article"
                v-if="infoLoader"
              ></v-skeleton-loader>
              <price-summary v-else :item="security"></price-summary>
              <TechnicalAnalysisWidget
                v-if="$vuetify.breakpoint.smAndUp"
                :height="399"
                :exchange="security.exchange"
                :symbol="security.symbol"
                class="technical"
              />
            </v-col>
          </v-row>
          <v-divider v-if="fullSreenwidth !== 8"></v-divider>
          <v-row v-if="$vuetify.breakpoint.mdAndUp" no-gutters>
            <v-col cols="12" class="pt-4">
              <v-skeleton-loader
                width="100%"
                type="article"
                v-if="infoLoader"
              ></v-skeleton-loader>
              <div v-else>
                <div>
                  <div class="overview_title__class d-xs-none">
                    About {{ security.symbol }}
                  </div>
                  <div class="d-sm-flex pt-2">
                    <div class="overview_text__class d-flex">
                      Industry:
                      <span
                        v-if="security.industry"
                        class="overview_text_value__class pl-1"
                        >{{ security.industry }}</span
                      >
                    </div>
                    <div class="overview_text__class ml-sm-4 d-flex">
                      Sector:
                      <span
                        v-if="security.sector"
                        class="overview_text_value__class pl-1"
                        >{{ security.sector }}</span
                      >
                    </div>
                  </div>
                  <div
                    v-if="security.description"
                    class="overview_des__class pt-3"
                  >
                    <div v-if="!desMore">
                      {{ security.description.substring(0, 330) }}...
                      <span class="show_more" @click="desMore = !desMore"
                        >Read more</span
                      >
                    </div>
                    <div v-else>
                      {{ security.description }}.
                      <span class="show_more" @click="desMore = !desMore"
                        >Read less</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <div v-if="$vuetify.breakpoint.xsOnly">
      <v-card class="mt-3">
        <v-card-title class="price-summary"> Price Summary </v-card-title>
        <v-card-text>
          <price-summary :item="security"></price-summary>
        </v-card-text>
      </v-card>
      <!-- {{ security.symbol }} -->

      <v-card class="mt-3 pb-0">
        <v-card-text class="pa-0 mb-0">
          <TechnicalAnalysisWidget
            v-if="is_security && timeSeries.length"
            :height="399"
            :exchange="security.exchange"
            :symbol="security.symbol"
            class="technical"
          />
        </v-card-text>
      </v-card>
    </div>
    <div v-if="!graphLoader" class="py-7">
      <tab-section :security="security"></tab-section>
    </div>
    <ReportListDialog />
    <UploadReportDialog />
  </div>
</template>

<script>
import Axios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import commonFunctions from "@/common/commonFunctions";
import { mapGetters, mapActions } from "vuex";
import helper from "@/helper/index";
import UploadReportDialog from "@/components/Trending/ResearchReport/UploadReportDialog";
export default {
  name: "Search",
  components: {
    UploadReportDialog,
    ReportListDialog: () =>
      import("@/components/Trending/ResearchReport/ReportsListDialog.vue"),
    LightWeightGraph: () =>
      import("@/components/SecurityPage/LightWeightGraph/LightWeightGraph.vue"),
    GraphTab: () => import("@/components/SecurityPage/GraphTab/GraphTab.vue"),
    DateFilterTab: () =>
      import("@/components/SecurityPage/DateFilterTab/DateFilterTab.vue"),
    PriceSummary: () =>
      import("@/components/SecurityPage/PriceSummary/PriceSummary.vue"),
    TabSection: () =>
      import("@/components/SecurityPage/TabSection/TabSection.vue"),
    TechnicalAnalysisWidget: () =>
      import(
        "@/components/SecurityPage/TechnicalAnalysisWidget/TechnicalAnalysisWidget.vue"
      ),
  },
  data: () => ({
    resizeLoader: false,
    graphLoader: true,
    desMore: false,
    fullSreenwidth: 8,
    selectedTab: null,
    trades: [],
    checkPreview: null,
    infoLoader: false,
    timeSeries: [],
    filterValue: 0,
    watchlistTabs: [],
    // graphType: 0,
    graphTypeItems: [
      {
        icon: "mdi-chart-line",
        value: "area",
        src: require("@/assets/securitypage/linegraph.svg"),
        activeSrc: require("@/assets/securitypage/linegraphactive.svg"),
      },
      {
        icon: "mdi-chart-box-outline",
        value: "candleStick",
        src: require("@/assets/securitypage/candlegraph.svg"),
        activeSrc: require("@/assets/securitypage/activecandlegraph.svg"),
      },
    ],
    filterItems: [
      // { text: "1D", value: "1DAY" },
      { text: "1W", value: "1WEEK" },
      { text: "1M", value: "1MONTH" },
      { text: "3M", value: "3MONTH" },
      { text: "6M", value: "6MONTH" },
      { text: "1Y", value: "1YEAR" },
      { text: "All", value: "ALL" },
    ],
    profiles: [],
    security: {},
    tradesLoading: false,
    socket: null,
    changed: false,
  }),
  computed: {
    ...mapGetters({
      getSelected: "securityPage/getGraphfilter",
    }),
    // fullSreenwidth() {
    //   if (this.$vuetify.breakpoint.smAndUp) {
    //     return 8;
    //   } else {
    //     return 12;
    //   }
    // },
    user_detail() {
      // is_sebi_registered
      return this.$store.state.user.user_detail;
    },
    is_fullscreen() {
      return document.fullscreenElement;
    },
    is_security() {
      return Object.keys(this.security) !== 0;
    },
    graphType() {
      return this.getSelected;
    },
    timeSeriesFilter() {
      return this.filterItems[this.filterValue].value;
    },
    profitLossPercent() {
      const price = this.security.live_price - this.security.close_price;
      const percent = ((price / this.security.close_price) * 100).toFixed(2);
      return percent;
    },
    incrementDecrementData() {
      const price = this.security.live_price - this.security.close_price;
      return price.toFixed(2);
    },
    profitLossIcon() {
      if (this.incrementDecrementData > 0) {
        return "mdi-arrow-up";
      } else {
        return "mdi-arrow-down";
      }
    },
    incrementDecrementIcon() {
      if (this.profitLossPercent > 0) {
        return "mdi-plus";
      } else {
        return "mdi-minus";
      }
    },
  },
  watch: {
    "$vuetify.breakpoint.smAndUp": function (value) {
      console.log(value);
    },
    graphType() {},
    filterValue() {
      this.graphLoader = true;
      this.getTimeSeriesData();
    },
  },
  methods: {
    ...mapActions({
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    uploadReportDialog() {
      this.$store.commit("ResearchReport/toggleUploadReportModal", {
        show: true,
      });
    },
    openReportList() {
      this.$store.commit("ResearchReport/toggleReportListModal", {
        show: true,
        item: this.security,
      });
      console.log(this.security, "security etail");
    },
    addTrade() {
      if (!commonFunctions.IsAuth()) {
        this.$router.push({ name: "login" });
        return "";
      }
      this.toggleAddTradeModal({
        show: true,
        type: "add",
        security: this.security,
      });
    },
    getCols() {
      if (this.fullSreenwidth == 8 && this.$vuetify.breakpoint.smAndUp) {
        return 4;
      } else if (
        this.fullSreenwidth !== 8 &&
        this.$vuetify.breakpoint.smAndUp
      ) {
        return 6;
      } else if (this.$vuetify.breakpoint.xsOnly) {
        return 12;
      }
    },
    getTrades(item) {
      this.selectedTab = item;
    },
    takeSs(refValue) {
      console.log(refValue);
      let url = location.href;
      let text = `Hey check out ${this.security.symbol} stock on Covesto Social Trading Platform.`;
      let title = "Stock Detail";
      helper.shareSsAndLink(refValue, url, text, title);
    },
    fullScreen() {
      // If the document is not currently in fullscreen mode, request fullscreen
      this.graphLoader = true;
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      }
      // Otherwise, exit fullscreen mode
      else {
        document.exitFullscreen();
      }
      this.graphLoader = false;
    },
    fullWidth(width) {
      this.resizeLoader = true;
      this.graphLoader = true;
      if (width == 12) {
        this.fullSreenwidth = 8;
      } else {
        this.fullSreenwidth = 12;
      }
      setTimeout(() => {
        this.resizeLoader = false;
        this.graphLoader = false;
      }, 500);
      this.resizeLoader = false;
    },
    getWatchlistTabs(type) {
      // console.log("user id", commonFunctions.getUserId());
      const onSuccess = (res) => {
        console.log(res.data);
        this.watchlistTabs = res.data;
      };
      const onFailure = () => {};
      let params = {};
      params["category__watchlist_type"] = type;
      params["profile__user__id"] = commonFunctions.getUserId();

      Axios("get", "watchlist/detail/", {
        params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
    addOrRemoveWatchlist(item, security) {
      console.log("secuity", security);
      console.log("item", item);
      if (!commonFunctions.IsAuth()) {
        this.$router.push({ name: "login" });
        return "";
      }
      const onSuccess = () => {
        // console.log(res);
        this.security.is_added_to_watchlist = true;
        this.eventBus.$emit("reload-watchlist");
      };
      const onFailure = () => {};
      let formData = {};
      formData["watchlist"] = item.id;
      formData["stock"] = security.id;
      // params["stock_id"] = item.id;
      // params["follower_id"] = commonFunctions.getUserId();
      // params["watcher_type"] = "stock";

      Axios("post", "watchlist/items/", {
        data: formData,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
    getSecurityInfo() {
      this.infoLoader = true;
      this.graphLoader = true;
      const onSuccess = (res) => {
        // console.log(res.data);
        this.security = res.data;
        this.infoLoader = false;
      };
      const onFailure = (err) => {
        console.error(err);
        this.infoLoader = false;
      };
      const onFinally = () => {
        this.getTimeSeriesData();
      };
      let params = {};
      if (commonFunctions.getUserId()) {
        params["user_id"] = commonFunctions.getUserId();
      }
      Axios("get", `api/trade/security-info/${this.$route.params.query}`, {
        params,
        onSuccess,
        onFailure,
        onFinally,
        isTokenRequired: false,
      });
    },
    getTimeSeriesData() {
      const self = this;
      const onSuccess = (res) => {
        self.timeSeries = res.data.time_series;
        setTimeout(() => {
          this.graphLoader = false;
        }, 200);
        // if (!self.timeSeries.length && self.filterValue !== 5) {
        //   this.filterValue = 5;
        // }
      };
      const onFailure = () => {
        this.graphLoader = false;
      };
      const onFinally = () => {
        this.initializeWebSocket();
      };
      let params = {};
      params["stock_id"] = this.security.id;
      params["filters"] = this.timeSeriesFilter;
      Axios("get", apiUrl.TIME_SERIES_DATA_API, {
        params,
        onSuccess,
        onFailure,
        onFinally,
        isTokenRequired: false,
      });
    },
    initializeWebSocket() {
      // const socketUrl = "ws://localhost:8001/ws/security/";
      const socketUrl = process.env.VUE_APP_WEBSOCKET_URL;

      this.socket = new WebSocket(socketUrl);

      this.socket.onopen = () => {
        console.log("WebSocket connection established.");
        const data = {
          type: "security",
          id: [this.security.id],
        };
        this.socket.send(JSON.stringify(data));
      };

      this.socket.onmessage = (event) => {
        console.log(JSON.parse(event.data), "on message");
        const { fields } = JSON.parse(event.data);
        if (Object.keys(fields).length !== 0) {
          this.security.live_price = fields.live_price;
        }
        this.changed = true;
        setTimeout(() => {
          this.changed = false;
        }, 50);
      };

      this.socket.onclose = (error) => {
        console.log(error, "WebSocket connection closed.");
      };
    },
    closeWebSocket() {
      if (this.socket) {
        this.socket.close();
      }
    },
  },
  beforeDestroy() {
    this.closeWebSocket();
  },

  mounted() {
    if (!this.$vuetify.breakpoint.smAndUp) {
      this.fullSreenwidth = 12;
    } else {
      this.fullSreenwidth = 8;
    }
    // this.getWatchlistTabs("stock");
    this.getSecurityInfo();
  },
};
</script>
<style>
::v-deep
  .tv-embed-widget-wrapper
  > .js-embed-widget-head
  > .tv-embed-widget-wrapper__body {
  border: none !important;
}
</style>
<style scoped>
.download-text {
  color: #575757;
  font-family: Avenir;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.39px;
}
.rupee-text {
  color: #2d8cff;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
}
.technical {
  height: 367px;
}
.about_header {
  color: #575757;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
}
.light-graph {
  margin-top: 25px;
}
.price-summary {
  color: #575757;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  margin-left: 10px;
}
.price-movement {
  color: #575757;
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.change_effect {
  /* Change background color */
  background-color: #ffcc00;
  /* Add a box shadow effect */
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
}
.text_btn >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
  /* identical to box height */

  color: #333333;
}

.text_btn {
  border: 1px solid #333333;
  margin-left: 5px;
}
.btn_trade {
  background: #2d8cff;
  margin-left: 5px;
}
.btn_trade >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  color: #ffffff;
}
.security_name__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 21px;
  line-height: 31px;
  /* identical to box height */

  color: #333333;
  width: 100%;
  word-wrap: break-word;
}
.symbol_exchange__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  color: rgba(51, 51, 51, 0.5);
}
.notfullwidth__class {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.fullwidth__class {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.tab_container__class {
  overflow-x: auto;
  padding-bottom: 10px;
}
.primary {
  color: #575757;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.overview_title__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #4d4d4d;
}
.overview_text__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 24px;
  /* or 185% */
  color: #4d4d4d;
}
.overview_des__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  /* or 185% */
  color: #333333;
}
.overview_text_value__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;

  color: #575757;
}
.show_more {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height */

  color: #2d8cff;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
@media all and (max-width: 600px) {
  .text_btn {
    min-width: 0px !important;
  }
  .live-price {
    font-weight: 900;
    font-size: 19px;
    line-height: 25.95px;
  }
  .symbol_exchange__class {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16.39px;
    /* identical to box height */

    color: rgba(51, 51, 51, 0.5);
  }

  .security_name__class {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    /* identical to box height */

    color: #333333;
  }
  .tab-section,
  .results-section,
  .tab {
    width: 100% !important;
    padding: 0px !important;
  }
  .tab-section,
  .results-section {
    padding: 10px !important;
  }
  .card-container {
    grid-row-gap: 10px;
    width: 100% !important;
    display: grid;
    grid-template-columns: repeat(1, 100%) !important;
    justify-content: space-between;
  }
  .security-info-card {
    width: 100% !important;
    padding: 10px !important;
    margin: 10px 0px !important;
  }
  .results-section {
    padding: 15px !important;
  }
}
.trade-tabs {
  width: 100%;
}
.security-info-card {
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.13);
  border-radius: 8px;
  width: 30%;
  padding: 20px;

  margin: 10px 20px;
}
.tab-section,
.results-section {
  width: 70%;
  padding: 10px 40px;
}
.tab {
  width: 70%;
  text-transform: capitalize;
  letter-spacing: 0px;
  border-bottom: 0.0006em solid lightgray;
}

.live-price {
  font-weight: 900;
  font-size: 20px;
  padding-right: 10px;
}
.profit-percent {
  color: #27ae60;
}
.increment,
.greenColor {
  color: #27ae60;
}
.increment,
.decrement {
  padding-right: 5px;
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
}
.decrement,
.redColor {
  color: #eb5757;
}
.loss-percent,
.profit-percent {
  font-size: 13px;
}
.loss-percent {
  color: #eb5757;
}
@media all and (min-width: 1100px) {
  .tab-section,
  .results-section {
    width: 60% !important;
    padding: 25px;
  }
  .card-container {
    grid-row-gap: 10px;
    width: 100% !important;
    display: grid;
    grid-template-columns: repeat(2, 49.33%) !important;
    justify-content: space-between;
  }
}
</style>
